import { render, staticRenderFns } from "./ModalSuccessDelete.vue?vue&type=template&id=a8a171b0&scoped=true"
import script from "./ModalSuccessDelete.vue?vue&type=script&lang=js"
export * from "./ModalSuccessDelete.vue?vue&type=script&lang=js"
import style0 from "./ModalSuccessDelete.vue?vue&type=style&index=0&id=a8a171b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a171b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg})
